import VendedorRevendaService from "@/services/VendedorRevendaService";

export const vendedorRevenda = {
  namespaced: true,
  state: {
    revenda: {},
  },
  actions: {
    getVendedorRevenda({ commit }, payload) {
      return VendedorRevendaService.GetVendedorRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendedorRevenda({ commit }, payload) {
      return VendedorRevendaService.PostVendedorRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendedorRevenda({ commit }, payload) {
      return VendedorRevendaService.PutVendedorRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendedorRevenda({ commit }, payload) {
      return VendedorRevendaService.DeleteVendedorRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendedorRevendaOData({ commit }, payload) {
      return VendedorRevendaService.GetVendedorRevendaOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendedorRevenda;
